import {SafetyTaskProps} from "./SafetyPlay";
import {Answer} from "../../Shared/Model/GameData";
import arrayShuffle from "array-shuffle";
import React, {useEffect, useState} from "react";

export default function SafetyPhoto(props: SafetyTaskProps) {

    useEffect(() => {
        props.onLoaded()
    })

    const [positions] = useState(
        arrayShuffle(props.task.answers.map((answer, index) => Math.ceil(index * Math.random())))
    )

    const className = (answer: Answer, index: number) => {
        if (props.solve || props.selectedAnswerIndex !== undefined) {
            if (answer.correct) {
                return "correct"
            } else if (index === props.selectedAnswerIndex || props.selectedAnswerIndex === undefined) {
                return "wrong"
            }
        }
    }

    return <div className="photo">
        {props.task.answers.map((answer, index) =>
            <img key={index} src={answer.picture} onClick={() => {
                props.onFinish(answer.correct, index)
            }} className={className(answer, index)} style={{order: positions[index]}} alt="" />
    )}</div>
}